const EmptySection = ({ message }) => {
    return (
        <div style={styles.container}>
            <div style={styles.icon}>📄</div>
            <div style={styles.message}>{message}</div>
        </div>
    );
};

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "300px",
        padding: "24px",
        border: "2px dashed #d1d5db",
        borderRadius: "12px",
        backgroundColor: "#f9fafb",
        color: "#6b7280",
        textAlign: "center",
    },
    icon: {
        fontSize: "48px",
        marginBottom: "12px",
    },
    message: {
        fontSize: "16px",
        fontWeight: "500",
    },
};

export default EmptySection;
